import {
  useRestoreCancelledSubscriptionMutation,
  ListSubscriptionDocument,
  ListSubscriptionQuery,
} from '@/types/generated/graphql';
import { notification } from 'antd';
import { useState } from 'react';
import { useSubscriptionStore } from '../store/use-subscription-store';

export type UseResumptionReturnType = {
  open: boolean;
  loading: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  onSubmit: () => Promise<void>;
};

export const useResumption = (): UseResumptionReturnType => {
  const subscriptionStore = useSubscriptionStore.getState();

  const [open, setOpen] = useState(false);

  const [restoreSubscription, { loading }] = useRestoreCancelledSubscriptionMutation({
    onCompleted: (data) => {
      notification.success({
        message: data?.restoreCancelledSubscription?.message,
      });
    },
    onError: (error) => {
      notification.error({
        message: error?.message,
      });
    },
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async () => {
    await restoreSubscription({
      update(cache) {
        const cachedData = cache.readQuery<ListSubscriptionQuery>({ query: ListSubscriptionDocument });

        if (!cachedData?.listSubscription?.edges) return;

        const updatedEdges = cachedData.listSubscription.edges.map((edge) => {
          if (!edge) return edge;
          if (edge.itemProductFamily === 'calilio-workspace') {
            return {
              ...edge,
              status: 'active',
              __typename: edge.__typename,
            };
          }
          return edge;
        });

        cache.writeQuery<ListSubscriptionQuery>({
          query: ListSubscriptionDocument,
          data: {
            listSubscription: {
              ...cachedData.listSubscription,
              edges: updatedEdges,
              __typename: cachedData.listSubscription.__typename,
            },
          },
        });
      },
    });
    subscriptionStore.setSubscription({
      listSubscription: {
        edges: [
          {
            ...subscriptionStore.planSubscription,
            status: 'active',
          },
        ],
      },
    });

    handleClose();
  };

  return {
    open,
    loading,
    handleOpen,
    handleClose,
    onSubmit,
  };
};
